module.exports = __webpack_public_path__ + "res/31-img_game_bg.5c051c72a31d8d7bf20103535d5645ce.png";